import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import SavedFilters from './saved-filters';
import {
  FilterGroupLogicPayload,
  Filters,
  PinUnpinActionType,
  ProspectListPayload,
  SavedFilter,
} from '../../../../types';
import {
  setSelectedSavedView,
  removedSelectedSavedView,
  resetFilterGroupLogic,
  setProspectViewIdFilter,
  setFilters,
} from '../../../../prospect-slice';
import {
  getContactListByViewIdRequest,
  getProspectListCountRequest,
  getProspectListRequest,
  pinUnpinSavedFilterRequest,
  getFilterViewListRequest,
} from '../../../../extra-actions';

const mapStateToProps = (state: RootState) => ({
  filters: state.prospect.filters,
  savedFilters: state.prospect.savedFilters,
  selectedSavedView: state.prospect.selectedSavedView,

  prospectCount: state.prospect.prospectCount,

  getProspectListCountRequestStatus:
    state.prospect.getProspectListCountRequest.status,

  pinUnpinSavedFilterRequestStatus:
    state.prospect.pinUnpinSavedFilterRequest.status,

  getContactListByViewIdRequestStatus:
    state.prospect.getContactListByViewIdRequest.status,

  getProspectListRequestStatus: state.prospect.getProspectListRequest.status,
  getFieldsRequestStatus: state.prospect.getFieldsRequest.status,
  getFilterViewListRequestStatus:
    state.prospect.getFilterViewListRequest.status,
  activeViewId: state.prospect?.activeViewId || null,
});

const mapDispatchToProps = {
  sendGetContactListByViewIdRequest: (payload: {
    viewId: number;
    selectedField: string[];
  }) => getContactListByViewIdRequest(payload),
  sendGetProspectListRequest: (params: ProspectListPayload) =>
    getProspectListRequest(params),
  sendGetProspectListCountRequest: (payload: ProspectListPayload) =>
    getProspectListCountRequest(payload),
  sendPinUnpinSavedFilterRequest: (
    viewId: number,
    action: PinUnpinActionType,
  ) => pinUnpinSavedFilterRequest({ viewId, action }),
  getFilterViewListRequest: () => getFilterViewListRequest({}),

  setSelectedSavedView: (filter: SavedFilter) => setSelectedSavedView(filter),
  removedSelectedSavedView: () => removedSelectedSavedView(),
  resetFilterGroupLogic: () => resetFilterGroupLogic(),
  setProspectViewIdFilter: (payload: FilterGroupLogicPayload) =>
    setProspectViewIdFilter(payload),
  setProspectFilters: (payload: Partial<Filters>) => setFilters(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  fetchProspectListAndCount: (options?: {
    doNoSendFilterGroupLogic?: boolean;
    forceFetch?: boolean;
  }) => void;
};

export default connector(SavedFilters);
